/** @format */

import {useTheme} from '@mui/material/styles';

import {BarLabelProps} from '../types';

function BarLabel(props: BarLabelProps) {
  const theme = useTheme();
  const {x, y, height, value, valueType = 'number'} = props;

  if (value == null) {
    return null;
  }

  const formatNumber = (v: number) => {
    if (valueType === 'percent') {
      return v.toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return v.toLocaleString('ru-RU').replace(',', ' ');
  };

  const formattedValue = formatNumber(value);
  const isPositive = value > 0;
  const offset = 2;
  const textX = isPositive ? x + offset : x - offset;
  const textAnchor = isPositive ? 'start' : 'end';

  // Для отрицательных значений заменяем дефис на знак минуса
  const displayValue = isPositive ? `+${formattedValue}` : formattedValue.replace(/^-/, '−');

  return (
    <text
      x={textX}
      y={y + height / 2}
      fill={theme.palette.semantic_dark!.good.on}
      fontSize={14}
      fontWeight={500}
      textAnchor={textAnchor}
      dominantBaseline='middle'
      style={{pointerEvents: 'none'}}
    >
      {displayValue}
    </text>
  );
}

export default BarLabel;
